import { MessengerV2 } from 'lib-shared-legacy-types';
import { useCallback } from 'react';

import { bulletinboardsApi } from 'apis/bulletinboards';
import { DixaMessengerApiV2 } from 'components/settings/components/sections/dixaMessenger/api/dixaMessengersApi';
import { useAppSelector } from 'utils/redux/useAppSelector';

type UseAddBoardIdIfNeededReturn = (
  messengerSettings: MessengerV2,
) => Promise<MessengerV2>;

export function useAddBoardIdIfNeeded(
  API: DixaMessengerApiV2,
  messengerId?: string,
): UseAddBoardIdIfNeededReturn {
  const [createBoard] = bulletinboardsApi.useCreateBulletinBoardMutation();
  const organizationId = useAppSelector(
    (state) => state.settings.organization.organization.id,
  );

  const hasBulletinBoardSetup = (messengerSettings?: Partial<MessengerV2>) => {
    return Boolean(
      messengerSettings?.settings?.integrations?.bulletinBoard?.boardId,
    );
  };

  // Can throw error, so make sure you handle it
  const createBoardIfNeeded = useCallback(
    async (messenger: MessengerV2): Promise<MessengerV2> => {
      if (!messengerId || hasBulletinBoardSetup(messenger)) {
        return messenger;
      }

      const boardRes = await createBoard({ organizationId });

      if (!('data' in boardRes)) {
        return messenger;
      }

      const response = await API.patchSettings(messengerId, {
        integrations: {
          bulletinBoard: {
            boardId: boardRes.data.id,
            enabled: false,
          },
        },
      });

      return response;
    },
    [messengerId, organizationId, createBoard, API],
  );

  return createBoardIfNeeded;
}
